import { SET_UNREAD_INBOX_MESSAGE_COUNT,  SET_FEATURE_FLAG_EP } from "../../actions/inbox/InboxActions";

const initialState = {
  unreadMessageCount: null,
  latestUnreadMessageId: null,
  lastRequestedTime: null,
  featureFlagEP: true
};

const unreadMessagesReducer = (state = initialState, action) => {
  switch(action.type)
  {
    case SET_UNREAD_INBOX_MESSAGE_COUNT:
      return {
        ...state,
        unreadMessageCount: action.payload.UnreadMessageCount,
        latestUnreadMessageId: action.payload.LatestUnreadMessageId,
        lastRequestedTime: action.payload.LastRequestedTime
      };
    case SET_FEATURE_FLAG_EP:
      return {
        ...state,
        featureFlagEP: action.payload === undefined ? true : action.payload
      };
    default:
      return state; 
  }
};

export default unreadMessagesReducer;
